module.exports = __webpack_public_path__ + "static/media/available-apple.e438e2a8.png";